import React, { useState, useEffect, useCallback } from 'react';

import { routes, ui } from 'constants/config';
import request from 'utils/request_ajax';
import PageTitle from 'components/shared/PageTitle';
import useFetch from 'components/shared/hooks/useFetch';
import Select from 'components/shared/select';
import ArchivesTable from './table';

const Archives = props => {
  const params = new URLSearchParams(window.location.search);
  const [page, setPage] = useState(parseInt(params.get('page'), 10) || 1);
  const [type, setType] = useState(params.get('type') || 'lesson');
  const [query, setQuery] = useState(params.get('query') || '');
  const [selectedArchivables, setSelectedArchivables] = useState([]);
  const [bulkActionStatus, setbulkActionStatus] = useState({
    inProgress: null,
    success: null,
    done: null,
  });

  const {
    data = {},
    loading,
    error,
    runRequest,
  } = useFetch(routes.ARCHIVES({ page, type, query }));
  const { archivables, totalPages, totalResults, canUnarchive } = data;
  const { inProgress } = bulkActionStatus;

  const handleTypeChange = ({ target }) => {
    params.set('type', target.value);
    params.delete('query');
    params.delete('page');
    props.history.replace({
      pathname: props.location.pathname,
      search: params.toString(),
    });
    setPage(1);
    setQuery('');
    setType(target.value);
    setSelectedArchivables([]);
  };

  const handleQueryChange = value => {
    if (value) {
      params.set('query', value);
    } else {
      params.delete('query');
    }
    params.delete('page');
    props.history.replace({
      pathname: props.location.pathname,
      search: params.toString(),
    });
    setPage(1);
    setQuery(value);
    setSelectedArchivables([]);
  };

  const handlePageChange = useCallback(
    value => {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set('page', value);
      props.history.replace({
        pathname: props.location.pathname,
        search: searchParams.toString(),
      });
      setPage(value);
      setSelectedArchivables([]);
    },
    [props.history, props.location.pathname],
  );

  const handleBulkRestore = () => {
    const mappedArchivables = selectedArchivables.map(index => ({
      id: archivables[index].id,
      type,
    }));

    if (!inProgress) {
      setbulkActionStatus({ inProgress: true, success: null, done: false });

      request
        .post(routes.BULK_RESTORE, { archivables: mappedArchivables })
        .then(() => {
          setbulkActionStatus({
            inProgress: false,
            success: true,
            done: true,
          });

          setTimeout(() => {
            setbulkActionStatus({
              inProgress: null,
              success: null,
              done: null,
            });
            setSelectedArchivables([]);
            runRequest();
          }, ui.NOTIFICATION_SUCCESS_DELAY);
        })
        .catch(() => {
          setbulkActionStatus({
            inProgress: false,
            success: false,
            done: true,
          });
        });
    }
  };

  useEffect(() => {
    if (page > totalPages) {
      handlePageChange(totalPages);
    }
  }, [page, totalPages, handlePageChange]);

  return (
    <>
      <PageTitle title={t('archive.title')} />
      <div className="Index-header">
        <h1 className="Index-title">{t('archive.title')}</h1>
      </div>
      <div className="mb-128">
        <Select
          value={type}
          name="selectType"
          onChange={handleTypeChange}
          className="Select--ArchiveFilter mb-24 fz-16"
        >
          <option value="lesson">{t('archive.filters.lesson')}</option>
          <option value="user">{t('archive.filters.user')}</option>
          <option value="event">{t('archive.filters.event')}</option>
          <option value="group">{t('archive.filters.group')}</option>
          <option value="group::smart">
            {t('archive.filters.smart_group')}
          </option>

          <option value="path">
            {t('archive.filters.path_and_certification_path')}
          </option>

          <option value="practice/container">
            {t('archive.filters.practice_scenario')}
          </option>
        </Select>
        <ArchivesTable
          archivables={archivables}
          loading={loading}
          error={error}
          canUnarchive={!!canUnarchive}
          type={type}
          pageCount={totalPages}
          totalResults={totalResults}
          setPage={handlePageChange}
          page={page}
          query={query}
          setQuery={handleQueryChange}
          selectedArchivables={selectedArchivables}
          setSelectedArchivables={setSelectedArchivables}
          handleBulkRestore={handleBulkRestore}
          bulkActionStatus={bulkActionStatus}
        />
      </div>
    </>
  );
};

export default props => <Archives {...props} />;
